
/**
 * @ngdoc directive
 * @name editorial
 *
 * @description
 * Editorial
 */
module.directive('editorial', function ($compile, $document, scrolllocker) {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            edito: '=content',
            index: '=index'
        },
        template:
                '<div class="aqua-editorial {{edito.field_style}}" ng-style="{\'background-color\': edito.field_theme_editorial.color_background, \'color\': edito.field_theme_editorial.color_text}">' +
                '  <a ng-attr-name="{{edito.nid}}"></a>' +
                '  <div class="grid-main">' +
                '    <h1 ng-if="index==0" class="grid grid-center"><span class="aqua-editorial--title" ng-style="{\'color\': edito.field_theme_editorial.color_title}">{{edito.field_title_visible_web}}</span></h1>' +
                '    <h2 ng-if="index>0" class="grid grid-center"><span class="aqua-editorial--title" ng-style="{\'color\': edito.field_theme_editorial.color_title}">{{edito.field_title_visible_web}}</span></h2>' +
                '    <div class="grid-12 aqua-richtext">' +
                '      <div class="aqua-editorial--chapo"><h3>{{edito.field_teaser}}</h3></div>' +
                '      <div class="aqua-editorial--content" ng-class="{\'is-columner\': edito.field_format === \'2 colonnes\'}" ng-bind-html="edito.body | trustAsHtml"></div>' +
                '    </div>' +

                '  </div>' +
                '</div>'
    };
});
